import React, {
    Fragment,
    ReactElement,
} from 'react';
import PropTypes from 'prop-types';
import './dealer-selection-list.scss';
import cn from 'classnames';
import {
    DealerItem,
} from './EmbeddedDealerCodeChange';

function DealerSelectionList(props: { role: string; dealers: DealerItem[]; onClick: (dealerCode: string) => void; classname?: string}): ReactElement {
  return (
    <Fragment>
      <div className={cn('dealerSelectionList', {'dealerSelectionList__card': props.role === 'card'}, props.classname)}>
        <div className={'dealerSelectionList__heading'}>Select a dealership to view:</div>
        {props.dealers.map((dealer: DealerItem) => {
          return (
            <div
              className={'dealerSelectionList__item'}
              key={dealer.code}
              data-locator='dealer-list-item'
              tabIndex={0}
              onClick={(): void=> props.onClick(dealer.code)}
              onKeyDown={(event): void => {
                if (event.key === 'Enter') {
                  props.onClick(dealer.code)
                }
              }}
              role='link'
            >
              <div className={'dealerSelectionList__item__content'}>
                <span
                  className={'dealerSelectionList__item__content__link'}
                >
                  {dealer.name}
                </span>
                <span>{dealer.code}</span>
              </div>
            </div>
          )
        })}
      </div>
    </Fragment>
  );
}

DealerSelectionList.defaultProps = {
    role: 'card'
};

DealerSelectionList.propTypes = {
  dealers: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string,
    code: PropTypes.string,
    name: PropTypes.string,
    address: PropTypes.string
  })),
  onClick: PropTypes.func.isRequired,
    role: PropTypes.oneOf(['card', 'menu-item'])
};

export default DealerSelectionList;
